"use client";

import { useSession } from "next-auth/react";

export default function UpgradeTipWrapper({ children }: { children: React.ReactNode }) {
  const session = useSession();
  if (!session.data?.user) return null;
  return <>{children}</>;
}
